import { Observable, Subject } from 'rxjs';
import { asap } from 'rxjs/scheduler/asap';
import { MyNavigator } from 'typings/globals/cordova';
import Logger from 'utils/Logger';

import { LocationInfo, LocationSource } from './Location';

declare const navigator: MyNavigator;

export class ForegroundGeolocationPlugin implements LocationSource {
  private source$Subject: Subject<LocationInfo>;
  source$: Observable<LocationInfo>;

  constructor() {
    this.source$Subject = new Subject<LocationInfo>();
    this.source$ = this.source$Subject.shareReplay(1, null, asap);
  }

  getLocation(): Promise<LocationInfo> {
    Logger.log('ForegroundGeolocationPlugin ', 'start');
    try {
      if (!navigator.geolocation) {
        return new Promise(() => {});
      }
      return new Promise((resolve, reject) => {
        Logger.log('ForegroundGeolocationPlugin ', 'getCurrentPosition');
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 60 * 60 * 1000,
        });
      })
        .then(({ coords: { longitude, latitude } }) => ({
          location: { longitude, latitude },
          source: 'GPS',
          quality: 'STREET',
        }))
        .then((l: LocationInfo) => {
          Logger.log('ForegroundGeolocationPlugin ', l);
          // side effect, notify subject
          this.source$Subject.next(l);
          return l;
        });
    } catch (e) {
      console.error('ForegroundGeolocationPlugin  error', e);
      return new Promise(() => {});
    }
  }
}
